import { render, staticRenderFns } from "./ac-resource-upload.vue?vue&type=template&id=07d877ca&"
import script from "./ac-resource-upload.vue?vue&type=script&lang=js&"
export * from "./ac-resource-upload.vue?vue&type=script&lang=js&"
import style0 from "./ac-resource-upload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports